import comoCriarDesconto from './content/como-criar-desconto.md?raw';
import clubeDeVantagens from './content/clube-de-vantagens.md?raw';
import pontuacoesEspeciais from './content/pontuacoes-especiais.md?raw';
import metaDeFrentista from './content/meta-de-frentista.md?raw';
import vozDoClienteIa from './content/voz-do-cliente-ia.md?raw';
import dashboardV2 from './content/dashboard-v2.md?raw';
import bolao from './content/bolao.md?raw';
import roleta from './content/roleta.md?raw';
import campanhasRecuperacao from './content/campanhas-recuperacao.md?raw';
import cicloDeVida from './content/ciclo-de-vida.md?raw';
import extratoDeOperacoes from './content/extrato-de-operacoes.md?raw';
import integracaoSislav from './content/integracao-sislav.md?raw';
import pedidosAoDev from './content/pedidos-ao-dev.md?raw';
import { ManualEntry } from './types';

export const manualEntries: ManualEntry[] = [
  {
    slug: 'como-criar-desconto',
    title: 'Como Criar um Desconto',
    description: 'Aprenda a criar e gerenciar descontos de combustível para seus clientes.',
    category: 'Descontos',
    content: comoCriarDesconto,
  },
  {
    slug: 'clube-de-vantagens',
    title: 'Clube de Vantagens',
    description: 'Entenda como funcionam as campanhas de recompensas, regras, produtos e conquistas.',
    category: 'Clube de Vantagens',
    content: clubeDeVantagens,
  },
  {
    slug: 'bolao',
    title: 'Bolão',
    description: 'Cadastre jogos pontuais (Copa, finais, clássicos) e premie clientes que acertarem o placar exato — integrado ao Clube de Vantagens.',
    category: 'Clube de Vantagens',
    content: bolao,
  },
  {
    slug: 'roleta',
    title: 'Roleta da Sorte',
    description: 'Transforme a recompensa do Clube num giro: monte as fatias, defina peso e estoque, simule o custo e acompanhe quem girou e o que ganhou.',
    category: 'Clube de Vantagens',
    content: roleta,
  },
  {
    slug: 'pontuacoes-especiais',
    title: 'Pontuações Especiais',
    description: 'Entenda como funcionam as pontuações padrão e especial, fatores, prioridades e bônus.',
    category: 'Pontuações',
    content: pontuacoesEspeciais,
  },
  {
    slug: 'meta-de-frentista',
    title: 'Meta de Frentista',
    description: 'Entenda como criar quadros de metas, configurar regras e monitorar o desempenho dos frentistas.',
    category: 'Frentistas',
    content: metaDeFrentista,
  },
  {
    slug: 'voz-do-cliente-ia',
    title: 'Voz do Cliente · IA',
    description: 'Dashboard que combina a nota do cliente, a leitura da IA sobre os comentários e os pollItems selecionados — revelando risco silencioso, destaques, tendências e alertas automáticos.',
    category: 'Dashboards',
    content: vozDoClienteIa,
  },
  {
    slug: 'dashboard-v2',
    title: 'Painel 360',
    description: 'Entenda cada bloco do Painel 360 e o que fazer com ele: alertas acionáveis, pulso do período, ciclo de vida e receita em risco, economia de pontos, penetração do app na pista e ferramentas de engajamento — tudo comparado com o período anterior.',
    category: 'Dashboards',
    content: dashboardV2,
  },
  {
    slug: 'campanhas-recuperacao',
    title: 'Campanhas de recuperação',
    description: 'Monte um público de clientes que pararam de abastecer, ofereça um desconto por um tempo definido, avise por push e/ou SMS, e acompanhe quantos voltaram — com simulação de custo, níveis com duração e resultado por campanha.',
    category: 'Marketing',
    content: campanhasRecuperacao,
  },
  {
    slug: 'ciclo-de-vida',
    title: 'Ciclo de vida da base',
    description: 'Veja quantos clientes estão ativos, em risco ou inativos, filtre por etiqueta e crie uma campanha de recuperação já com o público certo selecionado.',
    category: 'Marketing',
    content: cicloDeVida,
  },
  {
    slug: 'extrato-de-operacoes',
    title: 'Extrato de operações',
    description: 'Abastecimentos, vendas no PDV e resgates do período, com o resumo em formato de DRE: vendas, descontos, cashback, resgates e resultado.',
    category: 'Relatórios',
    content: extratoDeOperacoes,
  },
  {
    slug: 'integracao-sislav',
    title: 'Integração Sislav (lavanderia)',
    description: 'Configure a Sislav: pontos nas lavagens e secagens, troca de pontos por lavagem com desconto e uso como recompensa do Clube.',
    category: 'Integrações',
    content: integracaoSislav,
  },
  {
    slug: 'pedidos-ao-dev',
    title: 'Pedidos ao dev',
    description: 'Como pedir uma mudança, uma investigação ou uma tarefa ao desenvolvimento: escrever bem o pedido, urgente ou normal, responder dúvidas e fechar.',
    category: 'Suporte',
    content: pedidosAoDev,
  },
];

export function getManualEntryBySlug(slug: string): ManualEntry | undefined {
  return manualEntries.find(entry => entry.slug === slug);
}

export function getManualEntriesByCategory(): Record<string, ManualEntry[]> {
  return manualEntries.reduce((acc, entry) => {
    if (!acc[entry.category]) acc[entry.category] = [];
    acc[entry.category].push(entry);
    return acc;
  }, {} as Record<string, ManualEntry[]>);
}

export type { ManualEntry } from './types';
